import React from 'react';
import PropTypes from 'prop-types';

import Spinner from 'shared-components/components/Spinner';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import integerWithThousandSeparator from 'shared-utils/src/integerWithThousandSeparator';

const ListLnk = ({
  isDrawing,
  totalListResults,
  device,
  isFetching,
  listUrl,
  drawingData,
}) => {
  const goToList = () => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'TapMapSeeAllResultsInList',
      position: 'MapArea',
    }, {}, true);
    document.location = listUrl;
  };

  if (!isDrawing && device === 'smartphone' && listUrl) {
    const text = !totalListResults
      ? <>Nessun risultato</>
      : <>Vedi <span className="tp-w--l">{integerWithThousandSeparator(totalListResults)}</span> in lista</>;
    return (
      <div className="csa_mapsearch__bod__map__listlnk pr--m pl--m c-bg--w b--s c-br--f0 c-txt--f0 tp-s--l tp-w--s tp-a--c" onClick={goToList}>
        {isFetching && !drawingData
          ? (
            <Spinner
              className="csa_mapsearch__bod__map__listlnk__spinner"
              color="f0"
              size="m"
              weight="l"
              inline
            />            
          ) : text}
      </div>
    );
  }
  return null;
};

export default ListLnk;

ListLnk.propTypes = {
  isDrawing: PropTypes.bool,
  totalListResults: PropTypes.number,
  device: PropTypes.string,
  isFetching: PropTypes.bool,
  listUrl: PropTypes.string,
  drawingData: PropTypes.instanceOf(Object),
};

ListLnk.defaultProps = {
  isDrawing: false,
  totalListResults: 0,
  device: '',
  isFetching: false,
  listUrl: '',
  drawingData: {},
};
